import { useCallback } from 'react';
import { APP_EVENT_TYPE } from 'modules/taboola-common-frontend-modules/app-events-aggregator/appEventType';
import { useAppEventContext } from 'modules/taboola-common-frontend-modules/app-events-aggregator/hooks/useAppEventContext';

export const SIMULATOR_MONITOR_ID = {
    CAMPAIGN_REPORT_HEADER: 'simulator-button-campaign-report-header',
    CAMPAIGN_NAME_CELL: 'simulator-button-campaign-name-cell',
};

export const useSimulatorMonitor = monitorId => {
    const { push: pushAppEvent } = useAppEventContext();

    const trackSimulatorClick = useCallback(() => {
        pushAppEvent({
            type: APP_EVENT_TYPE.CLICK,
            id: monitorId,
        });
    }, [monitorId, pushAppEvent]);

    return { trackSimulatorClick };
};
